import HorizontalScrollableContainer from "../Common/HorizontalScrollIContainer";
import { IoInformationCircleOutline, IoEllipsisVertical } from "react-icons/io5";
import { NetflixHeartInfo } from "../WeddingInfo/WeddingInfo";

interface NetflixHeartProps {
  heart: NetflixHeartInfo;
  onOpenImage?: (src: string, title?: string) => void; // ⬅ 추가
}

const TAP_THRESHOLD_PX = 8;

const NetflixHeartList: React.FC<NetflixHeartProps> = ({ heart, onOpenImage }) => {
  return (
    <div className="flex flex-col mt-12 text-left mb-8 mx-4">
      <div className="text-white font-bold -mb-2">{heart.sectionTitle}</div>

      <HorizontalScrollableContainer>
        <div className="flex space-x-3 -ml-4">
          {heart.images.map((imgSrc, index) => {
            let startX = 0;
            let startY = 0;
            let moved = false;

            const title = heart.titles?.[index];

            return (
              <button
                key={index}
                type="button"
                className="relative w-24 focus:outline-none"
                aria-label={title ?? "preview"}
                // ✅ 포커스로 인한 살짝 스크롤/점프 방지
                onMouseDown={(e) => e.preventDefault()}
                // ✅ 스크롤(드래그) 중에는 열지 않기
                onPointerDown={(e) => {
                  startX = e.clientX;
                  startY = e.clientY;
                  moved = false;
                  (e.currentTarget as HTMLButtonElement).blur();
                }}
                onPointerMove={(e) => {
                  const dx = Math.abs(e.clientX - startX);
                  const dy = Math.abs(e.clientY - startY);
                  if (dx > TAP_THRESHOLD_PX || dy > TAP_THRESHOLD_PX) moved = true;
                }}
                onPointerUp={() => {
                  if (moved) return;
                  onOpenImage?.(imgSrc, title);
                }}
              >
                <img
                  src={imgSrc}
                  alt={title ?? `image-${index + 1}`}
                  className="rounded-t-[4px] w-24 h-32 object-cover"
                  draggable={false}
                />

                <div className="absolute bottom-7 left-0 w-full">
                  <div className="text-white text-[10px] font-bold text-center">
                    {title}
                  </div>
                  <div className="h-0.5 bg-gray-500/90 rounded-full">
                    <div
                      className="h-full bg-red-600 rounded-full"
                      style={{ width: `${heart.percents?.[index] ?? 0}%` }}
                    />
                  </div>
                </div>

                <div className="flex bg-[#202020] h-7 rounded-b-lg items-center p-2 justify-between">
                  <IoInformationCircleOutline className="w-4 h-4 text-white font-bold" />
                  <IoEllipsisVertical className="w-4 h-4 text-white" />
                </div>
              </button>
            );
          })}
        </div>
      </HorizontalScrollableContainer>
    </div>
  );
};

export default NetflixHeartList;